export class DefaultMegaMenuSource {
    getMegaMenuContent(id) {
        console.warn(`Default Mega Menu Adapter does not support setting data-menu-id properties. Cannot fetch ${id}`);
        return null;
    }
}
